import { useTranslation } from 'react-i18next';
import { Button } from '@zep/ui';
import { useModalActions } from '../../../../hooks';
export const CreateSpaceButton = () => {
  const {
    t
  } = useTranslation(['home']);
  const {
    handleClickCreateSpace
  } = useModalActions();
  return <Button leftSlot={<img src="/images/light/spaceMe/plus_white_sm.svg" alt="empty icon" />} size="md" variant="primary" onClick={handleClickCreateSpace} data-sentry-element="Button" data-sentry-component="CreateSpaceButton" data-sentry-source-file="CreateSpaceButton.tsx">
      {t('home:space_me_create_space_button')}
    </Button>;
};